import { EmailSubscriptionCenterPage } from "@modules/investor-relations/pages";
import { useLoaderData } from "@remix-run/react";

export default function EmailSubscriptionCenter() {
  useLoaderData();

  return <EmailSubscriptionCenterPage />;
}
